import { Component, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';

@Component({
    selector: 'fp-language-switcher',
    templateUrl: './language-switcher.component.html',
    styleUrl: './language-switcher.component.scss',
    standalone: false
})
export class LanguageSwitcherComponent {
  languages = ['en', 'cz'];
  isOpen = false;
  currentLang: string;

  constructor(
    private translate: TranslateService,
    private store: Store
  ) {
    this.currentLang = this.translate.getCurrentLang() || localStorage.getItem('lang') || 'en';
    this.translate.onLangChange.subscribe(event => {
      this.currentLang = event.lang;
    });
  }
  changeLang(lang: string) {
    this.isOpen = false;
    this.currentLang = lang;
    this.translate.use(lang);
    localStorage.setItem('lang', lang); //should store language option for one device - language persistance
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  closeDropdown() {
    this.isOpen = false;
  }

  getOtherLanguages() {
    return this.languages.filter(lang => lang !== this.currentLang);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const clickedElement = event.target as HTMLElement;
    const dropdown = document.querySelector('.language-dropdown');

    if (dropdown && !dropdown.contains(clickedElement)) {
      this.isOpen = false;
    }
  }
}
